var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIcondevicespendant = function SvgIcondevicespendant(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Devices/SquareTemplate/devices.pendant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Devices/SquareTemplate/devices.pendant",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rope",
    stroke: "#979797",
    strokeWidth: 3,
    x: 21.872303,
    y: -8.13623439,
    width: 34.7777021,
    height: 15.1362344,
    rx: 7.5681172
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pendant",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(23.8203, 11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(8.9438, 12.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    stroke: "#303030",
    fill: "#FFFFFF",
    x: -8.44380395,
    y: -12.4290157,
    width: 31,
    height: 63,
    rx: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.0206, 0)",
    fill: "#303030"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.52847639,
    y: 0,
    width: 1.01423819,
    height: 6.14196861,
    rx: 0.507119097
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.79271458,
    y: 2.07489873,
    width: 1.01423819,
    height: 4.06706987,
    rx: 0.507119097
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.05695277,
    y: 3.46947574,
    width: 1.01423819,
    height: 2.67249286,
    rx: 0.507119097
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.8189894e-12,
    y: 3.46947574,
    width: 1.01423819,
    height: 2.67249286,
    rx: 0.507119097
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.26423819,
    y: 2.07489873,
    width: 1.01423819,
    height: 4.06706987,
    rx: 0.507119097
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#666666",
    x: 6.55619605,
    y: 14.597501,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#666666",
    x: 6.55619605,
    y: 38.597501,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#303030",
    strokeWidth: 0.5,
    fill: "#FFFFFF",
    cx: 7.05619605,
    cy: 27.3493274,
    r: 6.80619605
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    stroke: "#303030",
    strokeWidth: 0.5,
    fill: "#EFEFEF",
    x: 6.75,
    y: -7.75,
    width: 18.5,
    height: 8.18382357,
    rx: 2
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIcondevicespendant);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.devices.pendant.1c227239f19e4b1194f2ece1e738d3ab.svg";